<template>
    <div>
        <div class="second-header-wrap">
            <el-button @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" v-if="state === 1" @click.native="saveHandler(1)" size="medium">保存</el-button>
            <el-button type="primary" @click.native="saveHandler(2)" size="medium">发布</el-button>
        </div>
        <div class="main-container">
            <el-form
                :model="formData"
                label-width="150px"
                :rules="rules"
                ref="form"
            >
                <el-form-item label="主题" prop="title">
                    <div style="width: 459px;">
                        <el-input v-model="formData.title" maxlength="100" placeholder="主题（1-100字）"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="报名日期范围" prop="dateRange">
                    <el-date-picker
                        v-model="formData.startTime"
                        format="yyyy-MM-dd HH:mm"
                        type="datetime"
                        placeholder="开始日期"
                    >
                    </el-date-picker>至
                    <el-date-picker
                        v-model="formData.endTime"
                        format="yyyy-MM-dd HH:mm"
                        type="datetime"
                        placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="招生出生范围" prop="stuDateRange">
                    <el-date-picker
                        v-model="formData.beginYear"
                        format="yyyy-MM-dd"
                        type="date"
                        placeholder="开始日期"
                    >
                    </el-date-picker>至
                    <el-date-picker
                        v-model="formData.endYear"
                        format="yyyy-MM-dd"
                        type="date"
                        placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-show="false" label="封面" prop="logoURL">
                    <el-upload
                        class="logo-uploader"
                        :action="`${ basePath }common/addImageUp`"
                        :show-file-list="false"
                        :before-upload="beforeUploadHandler"
                        :on-success="coverUploadSuccessHandler"
                    >
                        <div v-if="formData.logoURL !== ''"
                             class="logo-image"
                             :style="{backgroundImage: `url(${formData.logoURL})`}"></div>
                        <div v-else class="upload-hint">+</div>
                    </el-upload>
                </el-form-item>
                <el-form-item v-show="false" label="发布到" prop="publishTo">
                    <div class="checkbox-container">
                        <el-checkbox-group
                            v-model="formData.publishTo"
                        >
                            <el-checkbox label="2" v-if="hasGonzhonghao">公众号</el-checkbox>
                            <el-checkbox label="3" v-if="hasWebsite">网站</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item v-if="[2, 3, 6].indexOf(schoolInfo.type) === -1" label="招生类型" prop="enrolType">
                    <div class="checkbox-container">
                        <el-radio-group
                            v-model="enrolType"
                        >
                            <el-radio label="1">小学</el-radio>
                            <el-radio label="2">初中</el-radio>
                        </el-radio-group>
                    </div>
                </el-form-item>
                <el-form-item v-show="false" label="发布类型" prop="publishType">
                    <div class="checkbox-container">
                        <el-radio-group v-model="formData.publishType">
                            <el-radio label="1">测试报名</el-radio>
                            <el-radio label="2">正式报名</el-radio>
                        </el-radio-group>

                    </div>
                </el-form-item>
                <el-form-item label="招生简章" prop="content">
                    <ueditor class="rich-editor" ref="ueditor" :defaultMes="formData.content"
                             @editModel="richTextEditHandler"></ueditor>
                </el-form-item>

            </el-form>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin';
    import {
        getNotice,
        editOrPublishSchoolEnrolNotice,
        getBasicInfo,
        queryInfo
    } from '@/api/primary/notice';
    import moment from 'moment';
    import Ueditor from '@/components/Ueditor';
    import {mapGetters} from 'vuex';

    export default {
        name: "NoticeAdd",
        data() {
            const daterangeValidator = (rule, value, callback) => {
                if(!this.formData.startTime || !this.formData.endTime) {
                    callback(new Error('报名日期范围不能为空！'));
                } else if(moment(this.formData.startTime).format('YYYY-MM-DD HH:mm') > moment(this.formData.endTime).format('YYYY-MM-DD HH:mm')) {
                    callback(new Error('报名日期开始日期必须小于结束日期！'));
                } else {
                    callback();
                }
            };
            const stuDaterangeValidator = (rule, value, callback) => {
                if(!this.formData.beginYear || !this.formData.endYear) {
                    callback(new Error('招生出生范围不能为空！'));
                } else if(moment(this.formData.beginYear).format('YYYY-MM-DD') > moment(this.formData.endYear).format('YYYY-MM-DD')) {
                    callback(new Error('招生出生范围开始日期必须小于结束日期！'));
                } else {
                    callback();
                }
            };

            return {
                id: this.$route.query.id,
                yearNum: '',
                state: null,
                enrolType: '1',
                hasGonzhonghao: true,
                hasWebsite: true,
                formData: {
                    title: '',
                    startTime: new Date(),
                    endTime: new Date(),
                    beginYear: new Date(),
                    endYear: new Date(),
                    logoURL: 'https://cdnfile-10043692.file.myqcloud.com/signup-cover.jpg',
                    content: '',
                    publishTo: [],
                    publishType: '1'
                },
                rules: {
                    title: [{
                        required: true, message: '主题不能为空', trigger: 'blur'
                    }],
                    dateRange: [{
                        required: true,
                        trigger: 'blur',
                        validator: daterangeValidator
                    }],
                    stuDateRange: [{
                        required: true,
                        trigger: 'blur',
                        validator: stuDaterangeValidator
                    }],
                    logoURL: [{
                        required: true, message: '封面不能为空', trigger: 'blur'
                    }],
                    content: [{
                        required: true, message: '招生简章不能为空', trigger: 'blur'
                    }]
                },
                templateList: []
            }
        },
        mixins: [baseMixin],
        created() {
            getBasicInfo()
                .then(res => res.data)
                .then(data => {
                    this.hasWebsite = data.data.isSendToWebsite === 1;
                });
            queryInfo()
                .then(res => res.data)
                .then(data => {
                    this.hasGonzhonghao = data.data.exist;
                });
            getNotice({
                noticeId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    if(data.result) {
                        const pageData = data.data;
                        this.formData.title = pageData.title;
                        this.formData.content = pageData.content;
                        this.formData.startTime = pageData.startTime;
                        this.formData.endTime = pageData.endTime;
                        this.formData.beginYear = pageData.beginYear;
                        this.formData.endYear = pageData.endYear;
                        this.enrolType = pageData.enrolType.toString();
                        this.formData.publishType = pageData.publishType.toString();
                        this.formData.publishTo = pageData.publishTo.split(',');
                        this.formData.logoURL = pageData.logoURL;
                        this.yearNum = pageData.yearNum;
                        this.state = pageData.state;
                        this.$refs.ueditor.setContent(pageData.content);
                    }
                })
        },
        computed: {
            ...mapGetters(['schoolInfo', 'userInfo'])
        },
        components: {
            Ueditor,
        },
        methods: {
            saveHandler(state) {
                this.formData.content = this.$refs.ueditor.getContent();

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let enrolType = 0;
                        if([2, 3, 6].indexOf(this.schoolInfo.type) === -1) {
                            enrolType = this.enrolType;
                        } else {
                            enrolType = this.schoolInfo.type === 2 ? 1 : 2;
                        }

                        const args = {};
                        args.id = this.id;
                        args.state = state;
                        args.enrolType = enrolType;
                        args.yearNum = moment().format('YYYY');
                        args.title = this.formData.title;
                        args.logoURL = this.formData.logoURL;
                        args.content = this.formData.content;
                        args.startTime = moment(this.formData.startTime).format('YYYY-MM-DD HH:mm');
                        args.endTime = moment(this.formData.endTime).format('YYYY-MM-DD HH:mm');
                        args.publishTo = this.formData.publishTo.join(',');
                        args.publishType = this.formData.publishType;

                        args.beginYear = moment(this.formData.beginYear).format('YYYY-MM-DD');
                        args.endYear = moment(this.formData.endYear).format('YYYY-MM-DD');

                        args.yearNum = this.yearNum;
                        args.content = this.$refs.ueditor.getContent();

                        this.$confirm(`是否确认${state === 1 ? '保存' : '发布'}?`, `${state === 1 ? '保存' : '发布'}`, {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            editOrPublishSchoolEnrolNotice(args)
                                .then(res => res.data)
                                .then(data => {
                                    if(data.result) {
                                        this.$message({
                                            message: state === 1 ? '保存公告成功' : '发布公告成功',
                                            type: 'success'
                                        });
                                        this.$router.back();
                                    }
                                });
                        }).catch(() => {
                        });
                    }
                });
            },
            beforeUploadHandler(file) {
                const ext = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
                const extList = ['jpg', 'png', 'bmp', 'jpeg'];
                if(extList.indexOf(ext) === -1) {
                    this.$message({
                        message: `封面后缀名必须是[${extList.join(', ')}]`,
                        type: 'error'
                    });
                    return false;
                }
            },
            richTextEditHandler(content) {
                this.formData.content = content;
                this.$refs.form.validateField('content');
            },
            coverUploadSuccessHandler(res) {
                this.formData.logoURL = res.data.url;
                this.$refs.form.validateField('logoURL');
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .main-container {
        width: 810px;
        margin: 10px auto;
    }
    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        vertical-align: top;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .logo-image {
        @include wh(317px, 175px);
        @include cover-bg;
    }
    /*.checkbox-container {*/
    /*    margin-top: 10px;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/views/primary/notice/NoticeEdit.vue